import { Typography } from '@mui/material';
import { fontSize, maxWidth, style, styled, textAlign } from '@mui/system';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

export const CustomTooltipp = styled('div')(({ theme }) => (props) => ({
  border: `2px solid ${theme.palette.border.border}`,
  boxShadow: `1px 1px 5px ${theme.palette.border.border}`,
  background: theme.palette.background.default,
  padding: props.padding || '5px',
  borderRadius: '5px',
  outline: 'none',
  [theme.breakpoints.up('xll')]: {
    border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.border}`),
    boxShadow: `${getStringProduct(1.25, '1px 1px 5px')} ${theme.palette.border.border}`,
    padding: getStringProduct(1.25, props.padding || '5px'),
    borderRadius: getStringProduct(1.25, '5px'),
    outline: 'none'
  },
  [theme.breakpoints.up('xlll')]: {
    border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.border}`),
    boxShadow: `${getStringProduct(1.66, '1px 1px 5px')} ${theme.palette.border.border}`,
    padding: getStringProduct(1.66, props.padding || '5px'),
    borderRadius: getStringProduct(1.66, '5px'),
    outline: 'none'
  },
  [theme.breakpoints.up('xl4')]: {
    border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.border}`),
    boxShadow: `${getStringProduct(2.46, '1px 1px 5px')} ${theme.palette.border.border}`,
    padding: getStringProduct(2.46, props.padding || '5px'),
    borderRadius: getStringProduct(2.46, '5px'),
    outline: 'none'
  }
}));

export const MaxWidth1440 = styled('div')(({ theme }) => (props) => ({
  maxWidth: '1440px',
  margin: '0 auto'
}));

export const StyledImage = styled('img')(({ theme }) => ({
  height: 32,
  width: 32,
  border: `2px solid ${theme.palette.border.border}`,
  borderRadius: '10px',
  background: theme.palette.background.default,
  [theme.breakpoints.up('xll')]: {
    height: getStringProduct(1.25, 32),
    width: getStringProduct(1.25, 32),
    border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.border}`),
    borderRadius: getStringProduct(1.25, '10px')
  },
  [theme.breakpoints.up('xlll')]: {
    height: getStringProduct(1.66, 32),
    width: getStringProduct(1.66, 32),
    border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.border}`),
    borderRadius: getStringProduct(1.66, '10px')
  },
  [theme.breakpoints.up('xl4')]: {
    height: getStringProduct(2.46, 32),
    width: getStringProduct(2.46, 32),
    border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.border}`),
    borderRadius: getStringProduct(2.46, '10px')
  }
}));

export const Legcolor = styled('div')(({ theme, height, width, backgroundcolor }) => ({
  height: height || '16px',
  width: width || '16px',
  background: backgroundcolor || theme.palette.primary.main,
  borderRadius: '1px',
  [theme.breakpoints.up('xll')]: {
    height: getStringProduct(1.25, height || '16px'),
    width: getStringProduct(1.25, width || '16px'),
    borderRadius: getStringProduct(1.25, '1px')
  },
  [theme.breakpoints.up('xlll')]: {
    height: getStringProduct(1.66, height || '16px'),
    width: getStringProduct(1.66, width || '16px'),
    borderRadius: getStringProduct(1.66, '1px')
  },
  [theme.breakpoints.up('xl4')]: {
    height: getStringProduct(2.46, height || '16px'),
    width: getStringProduct(2.46, width || '16px'),
    borderRadius: getStringProduct(2.46, '1px')
  }
}));

export const CardsWrapper = styled('div')(({ background, bordercolor, theme, height, padding }) => ({
  background: background || theme.palette.background.default,
  border: `2px solid ${bordercolor || theme.palette.border.containerborder}`,
  height: height || '100%',
  borderRadius: '10px',
  padding: padding || '8px',
  position: 'relative',

  [theme.breakpoints.up('xll')]: {
    border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(1.25, height || '100%'),
    borderRadius: getStringProduct(1.25, '10px'),
    padding: getStringProduct(1.25, padding || '8px')
  },
  [theme.breakpoints.up('xlll')]: {
    border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(1.66, height || '100%'),
    borderRadius: getStringProduct(1.66, '10px'),
    padding: getStringProduct(1.66, padding || '8px')
  },
  [theme.breakpoints.up('xl4')]: {
    border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.containerborder}`),
    height: getStringProduct(2.46, height || '100%'),
    borderRadius: getStringProduct(2.46, '10px'),
    padding: getStringProduct(2.46, padding || '8px')
  }
}));

export const StyledText = styled(Typography)(({ theme, fontweight }) => ({
  fontSize: '8px',
  fontWeight: fontweight || 400,
  color: '#ffffff',
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, '8px')
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, '8px')
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, '8px')
  }
}));

export const LegcolorWrapper = styled('div')(({ theme, bordercolor, firstgraph, secondgraph, thirdgraph, forthgraph }) => ({
  background: theme.palette.background.default,
  padding: firstgraph || secondgraph || thirdgraph || forthgraph ? '3.12px' : '5.76px',
  border: `1px solid ${bordercolor || theme.palette.primary.main}`,
  borderRadius: '3px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('xll')]: {
    padding: getStringProduct(1.25, firstgraph || secondgraph || thirdgraph || forthgraph ? '3.12px' : '5.76px'),
    border: getDynamicBorder(1.25, `1px solid ${bordercolor || theme.palette.primary.main}`),
    borderRadius: getStringProduct(1.25, '3px')
  },
  [theme.breakpoints.up('xlll')]: {
    padding: getStringProduct(1.66, firstgraph || secondgraph || thirdgraph || forthgraph ? '3.12px' : '5.76px'),
    border: getDynamicBorder(1.66, `1px solid ${bordercolor || theme.palette.primary.main}`),
    borderRadius: getStringProduct(1.66, '3px')
  },
  [theme.breakpoints.up('xl4')]: {
    padding: getStringProduct(2.46, firstgraph || secondgraph || thirdgraph || forthgraph ? '3.12px' : '5.76px'),
    border: getDynamicBorder(2.46, `1px solid ${bordercolor || theme.palette.primary.main}`),
    borderRadius: getStringProduct(2.46, '3px')
    // borderRadius: '12px',
    // height: '42px',
    // width: '42px',
    // padding: firstgraph ? '5.5px' : secondgraph ? '5.5px' : thirdgraph ? '5.5px' : forthgraph ? '5.5px' : '18px',
    // border: `2px solid ${bordercolor || theme.palette.primary.main}`
  }
}));

export const CountsWrapper = styled('div')(({ theme }) => ({
  background: theme.palette.background.default,
  border: `1px solid ${theme.palette.border.tabsborder}`,
  borderRadius: '5px',
  padding: '4px',
  [theme.breakpoints.up('xll')]: {
    border: getDynamicBorder(1.25,`1px solid ${theme.palette.border.tabsborder}`),
    borderRadius: getStringProduct(1.25,'5px'),
    padding: getStringProduct(1.25, '4px')
  },
  [theme.breakpoints.up('xlll')]: {
    border: getDynamicBorder(1.66,`1px solid ${theme.palette.border.tabsborder}`),
    borderRadius: getStringProduct(1.66,'5px'),
    padding: getStringProduct(1.66, '4px')
  },
  [theme.breakpoints.up('xl4')]: {
    border: getDynamicBorder(2.46,`1px solid ${theme.palette.border.tabsborder}`),
    borderRadius: getStringProduct(2.46,'5px'),
    padding: getStringProduct(2.46, '4px')
  }
}));

export const PageTitle = styled('h6')(({ theme }) => ({
  border: `2px solid ${theme.palette.border.containerborder}`,
  padding: '10px',
  borderRadius: '10px',
  textAlign: 'center',
  margin: '0px',
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    textAlign: 'left'
  },
  [theme.breakpoints.up('xll')]: {
    border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.containerborder}`),
    padding: getStringProduct(1.25, '10px'),
    borderRadius: getStringProduct(1.25, '10px'),
    fontSize: getStringProduct(1.25, '16px')
  },
  [theme.breakpoints.up('xlll')]: {
    border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.containerborder}`),
    padding: getStringProduct(1.66, '10px'),
    borderRadius: getStringProduct(1.66, '10px'),
    fontSize: getStringProduct(1.66, '16px')
  },
  [theme.breakpoints.up('xl4')]: {
    border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.containerborder}`),
    padding: getStringProduct(2.46, '10px'),
    borderRadius: getStringProduct(2.46, '10px'),
    fontSize: getStringProduct(2.46, '16px')
  }
}));
